import { render, staticRenderFns } from "./CollationResultDetailUploadDataArea.vue?vue&type=template&id=8700a338&"
import script from "./CollationResultDetailUploadDataArea.vue?vue&type=script&lang=ts&"
export * from "./CollationResultDetailUploadDataArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports